import FileUploadIcon from "@mui/icons-material/FileUpload";
import { LoadingButton } from "@mui/lab";
import { Box, Input, Select, Stack, TextField, Typography } from "@mui/material";
import MenuItem from '@mui/material/MenuItem';
import { SelectChangeEvent } from '@mui/material/Select';
import { useApiUrl } from "@refinedev/core";
import { Create } from "@refinedev/mui";
import { useForm } from "@refinedev/react-hook-form";
import { useEffect, useState } from "react";
import { dataProvider } from "rest-data-provider";
import SiteSourceType from "@warriortrading/warriortrading.hermes.common.feathers/enums/siteSourceType";

export const RoomsCreate = () => {
    const {
        saveButtonProps,
        refineCore: { formLoading },
        register,
        formState: { errors },
        watch,
        setValue,
        setError,
    } = useForm();

    const [isUploadLoading, setIsUploadLoading] = useState(false);
    const [imgUrl, setImgUrl] = useState("");
    const imageInput = watch("avatarUrl");
    const apiUrl = useApiUrl();
    const [sourceTypeValue, setSourceTypeValue] = useState("");
    const onChangeHandler = async (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        try {
        setIsUploadLoading(true);
        const formData = new FormData();
        const target = event.target;
        const file: File = (target.files as FileList)[0];
        formData.append("uri", file);
        const res = await dataProvider(apiUrl).create({resource:'file', variables:formData})
        setValue("avatarUrl", res.data.rawUploadInfo.uri, {
            shouldValidate: true,
        });
        setImgUrl(res.data.rawUploadInfo.uri);
        setIsUploadLoading(false);
        } catch (error) {
        setError("avatarUrl", { message: "Upload failed. Please try again." });
        setIsUploadLoading(false);
        }
    };
    
    const [channelText, setChannelText] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    useEffect(() => {
        if (!(/[1-9]{1}[0-9]{4}0/.test(channelText) && channelText.length === 6)) {
            setErrorMessage(
                "Channel must be a six-digit number that cannot start with zero and must end with zero."
            );
        } else if ((errors as any)?.channel) {
            setErrorMessage(
                (errors as any)?.channel?.message
            );
        }
    }, [channelText, errors]);
    return (
        <Create isLoading={formLoading} saveButtonProps={saveButtonProps}>
            <Box
                component="form"
                sx={{ display: "flex", flexDirection: "column" }}
                autoComplete="off"
            >
                <TextField
                    {...register("title", {
                        required: "This field is required",
                    })}
                    error={!!(errors as any)?.title}
                    helperText={(errors as any)?.title?.message}
                    margin="normal"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    type="text"
                    label="Title"
                    name="title"
                />
                <TextField
                    {...register("channel", {
                        required: "This field is required",
                        validate: () => {
                            return /[1-9]{1}[0-9]{4}0/.test(channelText) && channelText.length === 6;
                        }
                    })}
                    error={channelText.length !== 6 || channelText["0"] === "0" || channelText["5"] !== "0" || !!(errors as any)?.channel}
                    helperText={errorMessage}
                    margin="normal"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    type="number"
                    label="Channel"
                    name="channel"
                    onChange={(e) => setChannelText(e.target.value)}
                />
                <Select
                    {...register("sourceType", {
                        required: "This field is required",
                    })}
                    value={sourceTypeValue}
                    label="RoomSourceType"
                    onChange = {(event: SelectChangeEvent) => setSourceTypeValue(event.target.value)}
                >
                    {
                        Object.values(SiteSourceType)[0].map((item: any) => {
                            return <MenuItem key={item.value} value={item.value}>{item.name}</MenuItem>
                        })
                    }
                </Select>
                <Stack
                    direction="row"
                    gap={4}
                    flexWrap="wrap"
                    sx={{ marginTop: "16px" }}
                    >
                    <label htmlFor="images-input">
                        <Input
                            {...register("avatarUrl", {
                            })}
                            id="images-input"
                            type="file"
                            sx={{ display: "none" }}
                            onChange={onChangeHandler}
                        />
                        <LoadingButton
                            loading={isUploadLoading}
                            loadingPosition="end"
                            endIcon={<FileUploadIcon />}
                            variant="contained"
                            component="span"
                        >
                            Upload Image
                        </LoadingButton>
                        <br />
                        {errors.avatarUrl && (
                        <Typography variant="caption" color="#fa541c">
                            {errors.avatarUrl?.message?.toString()}
                        </Typography>
                        )}
                    </label>
                    {imageInput && (
                        <Box
                        component="img"
                        sx={{
                            width: 50,
                            height: 50,
                        }}
                        src={imgUrl}
                        alt="Post image"
                        />
                    )}
                </Stack>
            </Box>
        </Create>
    );
};